module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "hero_video_landscape.b4c5bb37.mp4";